import React from "react";

export const Requests = ({ color, size, fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9531 2.8125H3.98438C3.33717 2.8125 2.8125 3.33717 2.8125 3.98438V11.9531C2.8125 12.6003 3.33717 13.125 3.98438 13.125H11.9531C12.6003 13.125 13.125 12.6003 13.125 11.9531V3.98438C13.125 3.33717 12.6003 2.8125 11.9531 2.8125Z"
        stroke={color}
        fill={fill ? color : undefined}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0156 2.8125H18.0469C17.3997 2.8125 16.875 3.33717 16.875 3.98438V11.9531C16.875 12.6003 17.3997 13.125 18.0469 13.125H26.0156C26.6628 13.125 27.1875 12.6003 27.1875 11.9531V3.98438C27.1875 3.33717 26.6628 2.8125 26.0156 2.8125Z"
        stroke={color}
        fill={fill ? color : undefined}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9531 16.875H3.98438C3.33717 16.875 2.8125 17.3997 2.8125 18.0469V26.0156C2.8125 26.6628 3.33717 27.1875 3.98438 27.1875H11.9531C12.6003 27.1875 13.125 26.6628 13.125 26.0156V18.0469C13.125 17.3997 12.6003 16.875 11.9531 16.875Z"
        stroke={color}
        fill={fill ? color : undefined}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0156 16.875H18.0469C17.3997 16.875 16.875 17.3997 16.875 18.0469V26.0156C16.875 26.6628 17.3997 27.1875 18.0469 27.1875H26.0156C26.6628 27.1875 27.1875 26.6628 27.1875 26.0156V18.0469C27.1875 17.3997 26.6628 16.875 26.0156 16.875Z"
        stroke={color}
        fill={fill ? color : undefined}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
